function Spinner({ percentage }: { percentage?: number }) {
  return (
    <svg viewBox='0 0 90 90'>
      <path
        d='M45 5 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80'
        fill='none'
        stroke={'#ffff'}
        strokeDasharray={
          percentage
            ? `${percentage * 251.2},${251.2 - percentage * 251.2}`
            : ''
        }
        strokeLinecap='round'
        strokeWidth={'8'}
      />
    </svg>
  );
}

export default Spinner;
